import { render, staticRenderFns } from "./AdminLinksList.vue?vue&type=template&id=1ade60bb&"
import script from "./AdminLinksList.vue?vue&type=script&lang=js&"
export * from "./AdminLinksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports